import { verticalKnot } from 'src/features/atoms/glove/drawer/common/back/lace/webKnots'
import { State } from 'src/types'
import { edgeOfBeltBackStyle } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/back/edge'
import { listCross } from 'src/features/atoms/glove/drawer/rightThrow/catchermitt/back/lace/listCross'

export const beltTypeDrawer = (ctx: CanvasRenderingContext2D, state: State): void => {
  edgeOfBeltBackStyle(ctx, state.edge.color, state.stitch.color)
  listCross(ctx, state.lace.color)
  verticalKnot(ctx, state.lace.color, 110, 190, 1) // ベルト結び目
}
